<template>
  <div class="modal-mask">
    <div class="modal-wrapper" @click.self="closeModal">
      <div :class="'modal-container ' + containerClass" >
        <div v-if="$slots.header" class="modal-header">
          <slot name="header"></slot>
        </div>

        <div class="modal-body">
          <slot name="body"></slot>
          <slot></slot>
        </div>

        <div v-if="$slots.footer" class="modal-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      containerClass: {
        type: String,
        default: ''
      }
    },
    methods: {
      closeModal () {
        this.$emit('closeModal');
      }
    }
  }
</script>

<style lang="scss">
  @import "../styles/components/modal";
</style>